export default __webpack_public_path__ + "static/media/arrow-right-line.3903403a.svg";